export default __webpack_public_path__ + "static/media/imgCamboriu.fbde8513.svg";